import axios from '../../plugins/Axios/axios';

const state = {
    adminCatalogGroupPermissionList: [],
    selectedCatalogGroup: {
        itemType: 'ADMINCATALOGGROUPPERMISSION',
        itemTitle: 'Admin Catalog Group Permission',
        path: '/CatalogGroup',
        data: {}
    }
};

// getters
const getters = {
    getAdminCatalogGroupPermissionList(state) {
        return state.adminCatalogGroupPermissionList;
    }
};

// actions
const actions = {
    GET_ADMINCATALOGGROUPPERMISSION_LIST({ commit }) {
        return axios.get(`admins?page=0`).then((response) => {
            commit('updateAdminCatalogGroupPermissionList', response.data.data.admins);
            return response;
        });
    }
};

// mutations
const mutations = {
    clear: (state) => {
        state.adminCatalogGroupPermissionList = [];
        state.selectedCatalogGroup = {
            itemType: 'ADMINCATALOGGROUPPERMISSION',
            itemTitle: 'Admin Catalog Group Permission',
            path: '/CatalogGroup',
            data: {}
        };
    },
    updateAdminCatalogGroupPermissionList: (state, adminList) => {
        state.adminList = adminList;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
